import { useEffect, useState } from "react";
import loading from '../../theme/img/loading-white.svg';

const Loader = ({ show = false }) => {
  if (!show) return null;

  return (
    <div
      style={{
        visibility: show ? "visible" : "hidden",
        opacity: show ? "1" : "0"
      }}
      className="loader-overlay"
    >
      <div className="loader-main">
        <img src={loading} className="loader-img" />
        <p>Almost there! We're processing your custom art — please don't close this page.</p>
      </div>
    </div>
  );
};

export default Loader;